// United Legacy 2026 – Main JS Entry
// Bundled from this file only; npm and local imports are resolved by the build.

import './components/_lucide-icons';
import './components/_mobile-nav';
import { heroParallax } from './components/_hero-parallax';
import { spotlightParallax } from './components/_spotlight-parallax';
import { communityFilters } from './components/_community-filters';
import { communityMap } from './components/_community-map';
import { testimonialCarousel } from './components/_testimonial-carousel';
import { headerScroll } from './components/_header-scroll';
import { legalToc } from './components/_legal-toc';

headerScroll();
heroParallax();
spotlightParallax();
communityMap();
communityFilters();
testimonialCarousel();
legalToc();